import apiRequest from "./apiClient";
import { fetchWithCache } from "../utils/adminCache";
import {
  DEFAULT_ANALYTICS_OVERVIEW,
  DEFAULT_BUYER_ANALYTICS,
  DEFAULT_DEVICE_ANALYTICS,
  DEFAULT_ORDER_STATS,
  DEFAULT_REVENUE_ANALYTICS,
  DEFAULT_REVENUE_STATS,
  DEFAULT_USER_STATS,
} from "../utils/adminStatsDefaults";

function dateRangeParams(startDate, endDate) {
  return `startDate=${startDate}&endDate=${endDate}`;
}

async function safeApi(path, fallback) {
  try {
    const body = await apiRequest(path);
    return body.data ?? fallback;
  } catch {
    return fallback;
  }
}

export async function fetchAnalyticsOverview(startDate, endDate, options = {}) {
  return fetchWithCache(
    `admin:analytics:overview:${startDate}:${endDate}`,
    () => safeApi(
      `/api/v1/admin/analytics/overview?${dateRangeParams(startDate, endDate)}`,
      DEFAULT_ANALYTICS_OVERVIEW
    ),
    { fallback: DEFAULT_ANALYTICS_OVERVIEW, ...options }
  );
}

export async function fetchOrderStats(options = {}) {
  return fetchWithCache(
    "admin:dashboard:stats:orders",
    () => safeApi("/api/v1/admin/dashboard/stats/orders", DEFAULT_ORDER_STATS),
    { fallback: DEFAULT_ORDER_STATS, ...options }
  );
}

export async function fetchUserStats(options = {}) {
  return fetchWithCache(
    "admin:dashboard:stats:users",
    () => safeApi("/api/v1/admin/dashboard/stats/users", DEFAULT_USER_STATS),
    { fallback: DEFAULT_USER_STATS, ...options }
  );
}

export async function fetchRevenueStats(options = {}) {
  return fetchWithCache(
    "admin:dashboard:stats:revenue",
    () => safeApi("/api/v1/admin/dashboard/stats/revenue", DEFAULT_REVENUE_STATS),
    { fallback: DEFAULT_REVENUE_STATS, ...options }
  );
}

export async function fetchRevenueAnalytics(startDate, endDate, options = {}) {
  return fetchWithCache(
    `admin:analytics:revenue:${startDate}:${endDate}`,
    () => safeApi(
      `/api/v1/admin/analytics/revenue?${dateRangeParams(startDate, endDate)}`,
      DEFAULT_REVENUE_ANALYTICS
    ),
    { fallback: DEFAULT_REVENUE_ANALYTICS, ...options }
  );
}

export async function fetchDeviceAnalytics(startDate, endDate, options = {}) {
  return fetchWithCache(
    `admin:analytics:devices:${startDate}:${endDate}`,
    () => safeApi(
      `/api/v1/admin/analytics/devices?${dateRangeParams(startDate, endDate)}`,
      DEFAULT_DEVICE_ANALYTICS
    ),
    { fallback: DEFAULT_DEVICE_ANALYTICS, ...options }
  );
}

export async function fetchBuyerAnalytics(startDate, endDate, options = {}) {
  return fetchWithCache(
    `admin:analytics:buyers:${startDate}:${endDate}`,
    () => safeApi(
      `/api/v1/admin/analytics/buyers?${dateRangeParams(startDate, endDate)}`,
      DEFAULT_BUYER_ANALYTICS
    ),
    { fallback: DEFAULT_BUYER_ANALYTICS, ...options }
  );
}
